module.exports = __webpack_public_path__ + "img/FR18689.6b7d4ae7.png";